import React from 'react'

const BlurContent = ({ children, blurIntensity = '10px', activated = true, message }) => {
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ filter: activated ? `blur(${blurIntensity})` : 'none', userSelect: 'none' }}>
        {children}
      </div>
      {message && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            width: '100%',
            pointerEvents: 'none',
            fontSize: '16px',
            color: '#5b5b5b'
          }}
        >
          {message}
        </div>
      )}
    </div>
  )
}

export default BlurContent
